export const ROUTES = {
  USER_MANAGEMENT: "USER",
  CREATOR_DETAIL: "CREATOR-DETAIL",
};
